export const bottomNav = [
  {
    label: `Home`,
    link: `/`,
    imageActive: `${process.env.CDN_URL}/images/main/mobile/homenav1.webp`,
    imageInactive: `${process.env.CDN_URL}/images/main/mobile/homenav1inactive.webp`,
  },
  {
    label: `Jadwal Saya`,
    link: `/jadwal_saya`,
    imageActive: `${process.env.CDN_URL}/images/main/mobile/homenav2.webp`,
    imageInactive: `${process.env.CDN_URL}/images/main/mobile/homenav2inactive.webp`,
  },
  {
    label: `Profile`,
    link: `/profile`,
    imageActive: `${process.env.CDN_URL}/images/main/mobile/homenav3.webp`,
    imageInactive: `${process.env.CDN_URL}/images/main/mobile/homenav3inactive.webp`,
  },
];

export const product = [
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/homenasabahsimpanan.webp`,
    label: `Penyimpan Potensial`,
    page: `rekomendasi_nasabah_simpanan`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/homenasabahpinjaman.webp`,
    label: `Peminjam Potensial`,
    page: `rekomendasi_nasabah_peminjam`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/homenasabahkeluar.webp`,
    label: `Nasabah Keluar`,
    page: `rekomendasi_nasabah_keluar`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/homeultramikro.webp`,
    label: `Mitra Ultra Mikro`,
    page: `rekomendasi_mitra_ultra_mikro`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/homehasiltl.webp`,
    label: `Evaluasi Hasil Tindak Lanjut`,
    page: `hasil_tindak_lanjut`,
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/homelainnya.webp`,
    label: `Lihat Lainnya`,
    page: `lihat_lainnya`,
  },
];

export const productMantri = [
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/rekomendasimitraumi-icon.webp`,
    label: `Rekomendasi Mitra Ultra Mikro`,
    page: `rekomendasi_mitra_ultra_mikro`,
    link: `/rekomendasi_mitra_ultra_mikro`, // musti diperbaharui
  },
  {
    icon: `${process.env.CDN_URL}/images/main/mobile/nasabahBridaya-icon.webp`,
    label: `Nasabah BRIDaya`,
    page: `nasabah_bridaya`,
    link: `/bridaya/rekomendasi`,
  },
];

export const bottomNavMantri = [
  {
    label: `Home`,
    link: `/`,
    imageActive: `${process.env.CDN_URL}/images/main/mobile/homenav1.webp`,
    imageInactive: `${process.env.CDN_URL}/images/main/mobile/homenav1inactive.webp`,
  },
  {
    label: `Profile`,
    link: `/profile`,
    imageActive: `${process.env.CDN_URL}/images/main/mobile/homenav3.webp`,
    imageInactive: `${process.env.CDN_URL}/images/main/mobile/homenav3inactive.webp`,
  },
];
